export enum ProductTypes {
    Batch = 'batch',
    Sms = 'sms',
    SmsCredits = 'sms_credits',
    AdvancedSignature = 'advanced_signature',
    SimpleSignature = 'simple_signature',
    QualifiedSignature = 'qualified_signature',
    SmartSignature = 'smart_signature',
    PhotoId = 'photo_id',
    CertifiedEmail = 'certified_email',
    CertifiedFile = 'certified_file',
    CertifiedSms = 'certified_sms',
}

export type MenuProductTypes = {
    [K in ProductTypes]: K extends 'advanced_signature' | 'simple_signature' | 'certified_email' | 'certified_sms'
        ? K
        : never;
}[ProductTypes];
